import { useState, useEffect } from 'react';
import axios from 'axios';

import routes from 'app/routes';

export default function useLastAssessment(memberId) {
  const [assessment, setAssessment] = useState(null);

  useEffect(() => {
    setAssessment(null);
    axios
      .get(routes.api.managers.members.lastAssessment(memberId))
      .then((response) => {
        setAssessment(response.data.data);
      });
  }, [memberId]);

  return assessment;
}
